module.exports = __webpack_public_path__ + "media/images/genese-ecbfeea4.jpg";